const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Visa24 = function Visa24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1434CB",
      d: "M10.872 8.148 7.468 16.27H5.247L3.572 9.789c-.102-.4-.19-.546-.5-.714-.504-.274-1.338-.53-2.072-.69l.05-.237h3.575c.455 0 .865.304.968.828l.885 4.7 2.187-5.528h2.207Zm8.701 5.47c.01-2.143-2.964-2.261-2.943-3.219.006-.291.284-.601.891-.68.301-.04 1.13-.07 2.071.363l.37-1.722A5.645 5.645 0 0 0 17.995 8c-2.077 0-3.538 1.104-3.55 2.685-.014 1.169 1.043 1.821 1.839 2.21.819.398 1.093.653 1.09 1.01-.006.544-.653.784-1.258.794-1.056.016-1.669-.286-2.157-.513l-.38 1.78c.49.225 1.396.421 2.336.43 2.207 0 3.65-1.09 3.657-2.778Zm5.484 2.652H27l-1.696-8.122H23.51a.956.956 0 0 0-.894.596l-3.152 7.526h2.206l.438-1.213h2.695l.254 1.213Zm-2.344-2.878 1.105-3.049.637 3.05h-1.742Zm-8.84-5.244-1.737 8.122h-2.1l1.737-8.122h2.1Z",
    })
  );
};
Visa24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "24",
  fill: "none",
  viewBox: "0 0 28 24",
};
var Visa32 = function Visa32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      width: "31",
      height: "23",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#CCC",
      rx: "3.5",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1434CB",
      d: "M12.112 8.137 8.97 15.634H6.92L5.374 9.65c-.094-.368-.175-.503-.461-.659-.466-.253-1.236-.49-1.913-.637l.046-.218h3.3c.42 0 .799.28.894.764l.817 4.338 2.018-5.102h2.037Zm8.033 5.05c.008-1.98-2.736-2.088-2.718-2.972.006-.27.262-.555.823-.628.278-.037 1.044-.064 1.912.335l.34-1.59A5.21 5.21 0 0 0 18.69 8c-1.917 0-3.266 1.019-3.278 2.478-.012 1.08.963 1.682 1.698 2.04.756.367 1.01.603 1.007.932-.006.503-.603.725-1.162.734-.974.015-1.54-.264-1.99-.474l-.352 1.643c.453.207 1.29.389 2.156.398 2.038 0 3.37-1.006 3.377-2.565Zm5.061 2.447H27l-1.566-7.497H23.78a.882.882 0 0 0-.825.55l-2.91 6.947h2.036l.404-1.12h2.488l.234 1.12Zm-2.163-2.657 1.02-2.814.588 2.814h-1.608Zm-8.16-4.84-1.603 7.497h-1.94l1.605-7.497h1.938Z",
    })
  );
};
Visa32.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 24",
};
const sizeMap = {
  24: Visa24,
  32: Visa32,
};
export function Visa(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Visa' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
